import Cookies from "js-cookie";
import {
  AddTabToIndexedDB,
  CheckIndexedDBIsSupport,
  GetAllTabsFromIndexedDB,
  GetTabByIdFromIndexedDB,
  RemoveTabFromIndexedDB,
  UpdateTabMerchantIdToIndexedDB,
} from "../IndexedDB/tabIndexedDB";
import { CheckBroadcastIsSupport } from "../broadcastChannel/tabChannel";
import { CheckStatusSocket, RemoveSocketSessionIdFromCookies, SocketConnect } from "./notificationHelper";

const sessionStorageTabIdKey = "tabId";
const masterNotificationTabIdKey = "masterNotificationTab";

export const GetTabIdFromSessionStorage = () => {
  let tabId = sessionStorage.getItem(sessionStorageTabIdKey);
  return tabId ? parseInt(tabId) : null;
};

const SetTabIdFromSessionStorage = (tabId) => {
  sessionStorage.setItem(sessionStorageTabIdKey, tabId);
};

export const GetMasterNotificationTabFromCookies = () => {
  let masterTabId = Cookies.get(masterNotificationTabIdKey);
  return masterTabId ? parseInt(masterTabId) : null;
};

const SetMasterNotificationTabFromCookies = (tabId) => {
  Cookies.set(masterNotificationTabIdKey, tabId);
};

const RemoveMasterNotificationTabFromCookies = () => {
  Cookies.remove(masterNotificationTabIdKey);
};

const RemoveMasterNotificationTabFromSessionStorage = () => {
  sessionStorage.removeItem(sessionStorageTabIdKey);
};

export const IsMasterTab = () => {
  if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
    let tabId = GetTabIdFromSessionStorage();
    let masterTabId = GetMasterNotificationTabFromCookies();
    return masterTabId == tabId;
  } else {
    return true;
  }
};
export const IsMasterTabAvailable = () => {
  let masterTabId = GetMasterNotificationTabFromCookies();
  return masterTabId ? masterTabId > 0 : 0;
};

export const ClearTabFromSessionStorage = () => {
  RemoveMasterNotificationTabFromSessionStorage();
};
export const ClearMasterTabFromCookies = () => {
  RemoveMasterNotificationTabFromCookies();
  RemoveSocketSessionIdFromCookies();
};
export const SetMasterTab = () => {
  let tabId = GetTabIdFromSessionStorage();
  if (!IsMasterTabAvailable()) {
    SetMasterBase(tabId);
  }
};

const SetTabID = (tabId) => {
  SetTabIdFromSessionStorage(tabId);
};

const SetMasterBase = (tabId) => {
  SetMasterNotificationTabFromCookies(tabId);
  CheckStatusSocket();
};

export const InsertTabIdToTabDB = async () => {
  let tabId = await AddTabToIndexedDB();
  if (tabId > 0) {
    SetTabID(tabId);
    SetMasterTab();
    SocketConnect();
  }
};

export const UpdateTabMerchantId = async (merchantId) => {
  let tabId = GetTabIdFromSessionStorage();
  if (tabId) {
    await UpdateTabMerchantIdToIndexedDB(tabId, merchantId);
  }
};

export const RemoveTabDB = async (tabId) => {
  await RemoveTabFromIndexedDB(tabId);
};

export const GetAllTabs = async () => {
  return await GetAllTabsFromIndexedDB();
};

export const GetTabById = async (tabId) => {
  return await GetTabByIdFromIndexedDB(tabId);
};
